import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as GreenMark } from '../../../../assets/things/green-mark.svg'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'

const ServicesTable = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
    })
  }, [])

  const content = ContentState.services?.table

  const params: any = content.map((c: any) => c[0])
  return (
    <div className="services-table">
      {width > 760 ? (
        <table className="services-table__table">
          <thead>
            <tr className="services-table__row">
              {content[0].map((c: any, i: number) => {
                if (!c || !c.length) return <></>

                return (
                  <td className="services-table__title" key={i}>
                    {c}
                  </td>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {content.slice(1, content.length).map((c: any, i: number) => (
              <tr className="services-table__row" key={i}>
                {c.map((ci: any, id: number) => {
                  if (!content[0][id] || !content[0][id].length) return <></>

                  if (!id)
                    return (
                      <td className="services-table__col col-main" key={id}>
                        <div className="services-table__col-icon">
                          <img src={ci.icon} />
                        </div>
                        <div
                          className="services-table__col-text"
                          dangerouslySetInnerHTML={{ __html: ci.title }}
                        ></div>
                      </td>
                    )
                  return (
                    <td className="services-table__col" key={id}>
                      <div
                        className={classNames(
                          'services-table__col-text',
                          typeof ci != 'boolean' && 'no-need',
                        )}
                      >
                        {ci == '1' && (
                          <div className="services-table__col-mark">
                            <GreenMark />
                          </div>
                        )}
                        {!ci.length && ''}
                        {ci != '1' && ci}
                      </div>
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="services-table__block">
          <div className="services-table__block-params">
            <div className="services-table__param main-title">{params[0]}</div>
            <div className="services-table__scroll">
              {params.slice(1, params.length).map((p: any, i: number) => {
                return (
                  <div className="services-table__param" key={i}>
                    {typeof p == 'string' ? (
                      p
                    ) : (
                      <>
                        <div className="services-table__col-icon">
                          <img src={p.icon} />
                        </div>
                        <div
                          className="services-table__col-text"
                          dangerouslySetInnerHTML={{ __html: p.title }}
                        ></div>
                      </>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          <div className="services-table__overflow">
            <table className="services-table__table">
              <thead>
                <tr className="services-table__row">
                  {content[0]
                    .slice(1, content[0].length)
                    .map((c: any, i: number) => {
                      if (!c || !c.length) return <></>

                      return (
                        <td className="services-table__title" key={i}>
                          {c}
                        </td>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {content.slice(1, content.length).map((c: any, i: number) => (
                  <tr className="services-table__row" key={i}>
                    {c.slice(1, c.length).map((ci: any, id: number) => {
                      if (
                        !content[0].slice(1, content[0].length)[id] ||
                        !content[0].slice(1, content[0].length)[id].length
                      )
                        return <></>
                      return (
                        <td className="services-table__col" key={id}>
                          <div
                            className={classNames(
                              'services-table__col-text',
                              typeof ci != 'boolean' && 'no-need',
                            )}
                          >
                            {ci == '1' && (
                              <div className="services-table__col-mark">
                                <GreenMark />
                              </div>
                            )}
                            {!ci.length && ''}
                            {ci != '1' && ci}
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
})

export default ServicesTable
